import { Mail } from "lucide-react";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useState } from "react";
import ComissaoEmailEnviado from "../model/ComissaoEmailEnviado";
import { useToastContext } from "../provider/ToastContext";
import ComissaoService from "../service/administracao/ComissaoService";

const comissaoService = new ComissaoService();

export default function EmailsComissaoEnviadosComponent() {
    const [emailsEnviados, setEmailsEnviados] = useState<ComissaoEmailEnviado[]>([]);
    const { msgErro } = useToastContext();

    useEffect(() => {
        comissaoService.buscarEmailsEnviados()
            .then(setEmailsEnviados)
            .catch((erro) => {
                msgErro("Erro ao carregar e-mails enviados", erro?.data?.message || "Tente novamente mais tarde.");
            });
    }, []);

    const dataHoraTemplate = (emailEnviado: ComissaoEmailEnviado) => {
        return new Date(emailEnviado.dataHoraEnvio).toLocaleString("pt-BR");
    };

    const header = (
        <div className="flex align-items-center gap-2">
            <Mail size={24} style={{ color: "var(--primary-color)" }} />
            <h5 className="m-0">E-mails de Comissão Enviados</h5>
        </div>
    );

    return (
        <div>
            <div className="mb-4">
                <h2>E-mails enviados</h2>
                <p className="text-muted">Consulte os e-mails enviados aos corretores.</p>
            </div>

            <Card>
                <DataTable
                    value={emailsEnviados}
                    dataKey="numeroContratoVenda"
                    header={header}
                    paginator
                    rows={10}
                    rowsPerPageOptions={[10, 25, 50]}
                    stripedRows
                    emptyMessage="Nenhum e-mail enviado encontrado."
                >
                    <Column field="numeroContratoVenda" header="Contrato" sortable />
                    <Column field="nomeCorretor" header="Corretor" sortable />
                    <Column field="email" header="E-mail" sortable />
                    <Column header="Data de envio" body={dataHoraTemplate} sortable sortField="dataHoraEnvio" />
                </DataTable>
            </Card>
        </div>
    );
}
